<script>
import moment from "moment";
import { mapActions } from "vuex";
import ClientFactory from "@/api/ClientFactory";
const api = ClientFactory.get("budgetreport");
const apiDropdown = ClientFactory.get("dropdowns");
import UploadFile from '../../../components/files/Upload.vue';
export default {
    components: {
        UploadFile,
    },
    data() {
        return{
            inputPeriod: 4,
            inputPeriodDetail: 1,
            inputReportName: "",
            inputCate: -1,
            inputReportYear: new Date().getFullYear(),
            inputPublishDate: new Date(),
            inputPublishTime: moment(new Date()).format("HH:mm:ss"),
            inputCircularsTemplateNo: "",
            inputCircularsNo: "",
            inputDocumentNo: "",
            inputNote: "",
            listCate: [],
            listPeriodDetail: [],
            listPeriod: [
                {
                    label: "Năm",
                    value: 4,
                },
                {
                    label: "Nửa năm",
                    value: 3,
                },
                {
                    label: "Tháng",
                    value: 1,
                },
                {
                    label: "Quý",
                    value: 2,
                },
                {
                    label: "9 tháng",
                    value: 5,
                },
            ],
            listMonth: [
                {
                    label: "Tháng 1",
                    value: 1,
                },
                {
                    label: "Tháng 2",
                    value: 2,
                },
                {
                    label: "Tháng 3",
                    value: 3,
                },
                {
                    label: "Tháng 4",
                    value: 4,
                },
                {
                    label: "Tháng 5",
                    value: 5,
                },
                {
                    label: "Tháng 6",
                    value: 6,
                },
                {
                    label: "Tháng 7",
                    value: 7,
                },
                {
                    label: "Tháng 8",
                    value: 8,
                },
                {
                    label: "Tháng 9",
                    value: 9,
                },
                {
                    label: "Tháng 10",
                    value: 10,
                },
                {
                    label: "Tháng 11",
                    value: 11,
                },
                {
                    label: "Tháng 12",
                    value: 12,
                },
            ],
            listQuarter: [
                {
                    label: "Quý 1",
                    value: 1,
                },
                {
                    label: "Quý 2",
                    value: 2,
                },
                {
                    label: "Quý 3",
                    value: 3,
                },
                {
                    label: "Quý 4",
                    value: 4,
                },
            ],
            listHalfYear: [
                {
                    label: "6 tháng đầu năm",
                    value: 1,
                },
                {
                    label: "6 tháng cuối năm",
                    value: 2,
                },
            ],
            dialog: {
                active: false,
                type: ""
            },
            attachments: {
                file_statistical: [],
                file_other: [],
                file_report: []
            },
            attachmentsFilesName: {
                file_statistical: [],
                file_other: [],
                file_report: []
            },
        }
    },
    methods: {
        ...mapActions("ui", ["loading", "closeLoading", "notify"]),
        periodChange() {
            if (this.inputPeriod == 1) {
                this.listPeriodDetail = this.listMonth;
            } else if (this.inputPeriod == 2)
                this.listPeriodDetail = this.listQuarter;
            else if (this.inputPeriod == 3)
                this.listPeriodDetail = this.listHalfYear;
            else {
                this.listPeriodDetail = [{ value: -1, label: "" }];
                this.inputPeriodDetail = -1;
            } 
        },
        validator() {
            return (
                !this.errors.any() &&
                this.inputReportName !== "" &&
                this.inputDocumentNo !== ""
            );
        },

        async addReport(status){
            this.$validator.validateAll();
            console.log(this.errors)
            if (!this.validator()) {
                return this.notify({
                    error: true,
                    text: "Dữ liệu không hợp lệ.",
                });
            }

            if(this.attachments.file_report.length == 0) {
                return this.notify({
                    error: true,
                    text: 'Văn bản/báo cáo là bắt buộc',
                });
            }
            /* if(this.attachments.file_statistical.length == 0) {
                return this.notify({
                    error: true,
                    text: 'Số liệu thống kê là bắt buộc',
                });
            } */

            this.loading(this.$vs);

            let response = await api.insReport({
                report_type_id: 0,
                cate_id: this.inputCate,
                report_name: this.inputReportName,
                report_year: this.inputReportYear,
                period_type: this.inputPeriod,
                period_value: this.inputPeriodDetail,
                document_no: this.inputDocumentNo,
                circulars_no: this.inputCircularsNo,
                circulars_template_no: this.inputCircularsTemplateNo,
                publish_date: moment(this.inputPublishDate).format("DD/MM/YYYY") + " " + this.inputPublishTime,
                note: this.inputNote,
                status: status
            });
            if (typeof response.error !== "undefined" || response.data.status === "failed") {
                return this.notify({
                    error: true,
                    text: response.error || response.data.message,
                });
            }
            var reportId = response.data.data[0].data;
            
            response = await api.insFile({
                budget_report_id: reportId,
                file_type_id: 1,
                file_id: this.attachments.file_report
            });
            if (typeof response.error !== "undefined" || response.data.status === "failed") {
                return this.notify({
                    error: true,
                    text: response.error || response.data.message,
                });
            }

            response = await api.insFile({
                budget_report_id: reportId,
                file_type_id: 2,
                file_id: this.attachments.file_statistical
            });
            if (typeof response.error !== "undefined" || response.data.status === "failed") {
                return this.notify({
                    error: true,
                    text: response.error || response.data.message,
                });
            }
            
            response = await api.insFile({
                budget_report_id: reportId,
                file_type_id: 3,
                file_id: this.attachments.file_other
            });
            if (typeof response.error !== "undefined" || response.data.status === "failed") {
                return this.notify({
                    error: true,
                    text: response.error || response.data.message,
                });
            }
            this.closeLoading();

            this.$router.back();
            return this.notify({
                text: "Thêm mới dữ liệu thành công",
            });
        },
        displayUploadDialog(type) {
            this.dialog.active = true;
            this.dialog.type = type;
        },
        uploadDone() {
            this.dialog.active = false;
            switch(this.dialog.type) {
                case "file_report":
                    this.attachments.file_report = this.$refs.uploadDialog.fileIds
                    this.attachmentsFilesName.file_report = this.$refs.uploadDialog.fileRecordsForUpload.map(item => {
                        return item.file.name
                    })
                    break;
                case "file_statistical":
                    this.attachments.file_statistical = this.$refs.uploadDialog.fileIds;
                    this.attachmentsFilesName.file_statistical = this.$refs.uploadDialog.fileRecordsForUpload.map(item => {
                        return item.file.name
                    })
                    break;
                case "file_other":
                    this.attachments.file_other = this.$refs.uploadDialog.fileIds;
                    this.attachmentsFilesName.file_other = this.$refs.uploadDialog.fileRecordsForUpload.map(item => {
                        return item.file.name
                    })
                    break;
                default:
                    break
            }
        },
    },
    async created() {
        this.loading(this.$vs);
        this.listCate = await apiDropdown.getItemsTree('BUDGET_REPORT_CATE');
        this.inputCate = this.listCate[0].value;
        this.closeLoading();
    },
    destroyed() {
        this.closeLoading();
    },
}
</script>
<template>
	<div>
		<CCard>
			<CCardHeader class="pt-1 pb-1">
				<h4>Thêm báo cáo công khai ngân sách</h4>
			</CCardHeader>
			<CCardBody class="pt-1 pb-1">
				<CRow class="mb-2">
					<CCol md="6" class="mt-2">
						<CInput
							v-model="inputReportName"
							label="Tên báo cáo (*)"
							v-validate="'required'"
                            placeholder="Điền tên báo cáo"
							name="Tên báo cáo"
						/>
						<span class="text-danger text-sm">{{
							errors.first("Tên báo cáo")
						}}</span>
					</CCol>
                    <CCol md="6" class="mt-2">
						<CSelect
							:value.sync="inputCate"
							label="Danh mục"
							:options="listCate"
						/>
					</CCol>
				</CRow>
				<CRow class="mb-2">
                    <CCol md="3" class="mt-2">
                        <CInput
							v-model="inputReportYear"
                            type="number"
							label="Năm"
						/>
                    </CCol>
					<CCol md="3" class="mt-2">
						<CSelect
							label="Kỳ báo cáo"
							:options="listPeriod"
							:value.sync="inputPeriod"
							@change="periodChange"
						/>
					</CCol>
                    <CCol sm="3" class="mt-2">
						<CSelect
							:class="inputPeriod != 4 && inputPeriod != 5 && inputPeriod != -1 ? 'visible' : 'invisible'"
							label="Loại kỳ báo cáo"
							:options="listPeriodDetail"
							:value.sync="inputPeriodDetail"
						/>
					</CCol>
				</CRow>
                <CRow class="mb-2">
					<CCol md="3" class="mt-2">
						<CInput
							v-model="inputDocumentNo"
							label="Số văn bản công bố (*)"
                            name="Số văn bản công bố"
                            placeholder="Điền số văn bản công bố"
                            v-validate="'required'"
						/>
                        <span class="text-danger text-sm">{{errors.first("Số văn bản công bố")}}</span>
					</CCol>
                    <CCol md="3" class="mt-2">
						<CInput
							v-model="inputCircularsNo"
							label="Số thông tư áp dụng"
                            name="Số thông tư áp dụng"
                            placeholder="Điền số thông tư áp dụng"
						/>
                        <span class="text-danger text-sm">{{errors.first("Số thông tư áp dụng")}}</span>
					</CCol>
                    <CCol md="2" class="mt-2">
						<CInput
							v-model="inputCircularsTemplateNo"
							label="Biểu mẫu thông tư"
                            name="Biểu mẫu thông tư"
                            placeholder="Điền tên biểu mẫu thông tư"
						/>
                        <span class="text-danger text-sm">{{errors.first("Biểu mẫu thông tư")}}</span>
					</CCol>
                    <CCol md="2" class="mt-2">
						<label for="datepicker">Ngày công bố</label>
						<b-form-datepicker
							id="datepicker"
							v-model="inputPublishDate"
							class="mb-2"
                            locale="vi"
                            placeholder="Chọn ngày công bố"
                            :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                            :hide-header=true
                            label-help=""
                            :value-as-date=true>
                        </b-form-datepicker>
					</CCol>
                    <CCol md="2" class="mt-2">
                        <label for="timepicker">Giờ công bố</label>
						<b-form-timepicker
                            id="timepicker"
                            v-model="inputPublishTime"
                            placeholder="Chọn giờ công bố"
                            hourCycle="h23"
                            :hide-header=true
                            no-close-button
                            locale="vi">
                        </b-form-timepicker>
					</CCol>
				</CRow>

                <CRow class="mb-2 mt-3">
                    <CCol sm="3" class="ml-0">
                        <span>Văn bản/báo cáo (*)</span>
                        <vs-button class="ml-0" square danger @click="displayUploadDialog('file_report')"><i class="bx bx-cloud-upload"></i> &nbsp; Chọn files</vs-button>
                        <span v-if="this.attachments.file_report.length > 0" style="color: #2eb85c" class="small">Đã tải lên {{this.attachments.file_report.length}} tệp tin</span>
                    </CCol>
                    <CCol sm="3">
                        <span>Số liệu thống kê</span>
                        <vs-button class="ml-0" square danger @click="displayUploadDialog('file_statistical')"><i class="bx bx-cloud-upload"></i> &nbsp; Chọn files</vs-button>
                        <span v-if="this.attachments.file_statistical.length > 0" style="color: #2eb85c;" class="small">Đã tải lên {{this.attachments.file_statistical.length}} tệp tin</span>
                    </CCol>
                    <CCol sm="3">
                        <span>Tệp đính kèm khác</span>
                        <vs-button class="ml-0" square danger @click="displayUploadDialog('file_other')"><i class="bx bx-cloud-upload"></i> &nbsp; Chọn files</vs-button>
                        <span v-if="this.attachments.file_other.length > 0" style="color: #2eb85c;" class="small">Đã tải lên {{this.attachments.file_other.length}} tệp tin</span>
                    </CCol>
                </CRow>
                <CRow class="mb-2">
					<CCol md="12" class="mt-2">
						<CTextarea
							v-model="inputNote"
                            placeholder="Điền nội dung ghi chú cho báo cáo"
							label="Ghi chú"
							rows="5"
						/>
					</CCol>
				</CRow>
				<CRow>
					<CCol md="12" class="mt-2">
						<div class="text-center">
                            <vs-button class="d-inline custom_btn_search" square danger @click="$router.back()"><i class="bx bx-left-arrow-alt"></i> &nbsp;Quay lại</vs-button>
							<vs-button class="d-inline" square @click="addReport(1)"><i class="bx bx-save"></i> &nbsp;Thêm mới</vs-button>
                            <vs-button class="d-inline" success square @click="addReport(2)"><i class="bx bx-save"></i> &nbsp;Công khai</vs-button>
						</div>
					</CCol>
				</CRow>
			</CCardBody>
		</CCard>
        <vs-dialog prevent-close width="600px" scroll overflow-hidden v-model="dialog.active">
            <template #header>
                <h4 class="not-margin">
                <b>Tải lên</b>
                </h4>
            </template>
            <UploadFile ref="uploadDialog"/>
            <template #footer>
                <div class="con-footer flex flex-end">
                    <vs-button square success @click="$refs.uploadDialog.uploadFiles()"><i class="bx bx-cloud-upload"></i> &nbsp; Bắt đầu tải</vs-button>
                    <vs-button square danger @click="uploadDone"><i class="bx bx-save"></i> &nbsp; Xong</vs-button>
                </div>
            </template>
        </vs-dialog>
	</div>
</template>